var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGearAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.093 10a2.91 2.91 0 1 0 5.818 0 2.91 2.91 0 0 0-5.818 0Zm2.91 1.454a1.454 1.454 0 1 0 0-2.909 1.454 1.454 0 0 0 0 2.91Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.453 14.858-1.612 1.613-2.064-.575-.59.243-1.06 1.86h-2.28l-1.053-1.866-.59-.247-2.064.567-1.611-1.611.575-2.064-.244-.59L2 11.126v-2.28l1.867-1.053.248-.59-.568-2.064 1.61-1.61 2.065.575.59-.243L8.868 2h2.28l1.054 1.867.59.248 2.063-.568 1.614 1.611-.575 2.064.243.59L18 8.87v2.28l-1.867 1.054-.248.59.568 2.064Zm-2.103-2.161.634-1.515 1.562-.881v-.584l-1.562-.888-.625-1.515.482-1.727-.414-.413-1.733.476-1.513-.634-.88-1.561h-.585l-.887 1.56-1.516.626-1.728-.482-.411.412.476 1.732-.634 1.513-1.561.88v.586l1.56.889.624 1.515-.481 1.728.413.412 1.732-.476 1.513.634.88 1.56h.586l.888-1.56 1.515-.624 1.728.481.413-.413-.476-1.731Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearAlt);
export default __webpack_public_path__ + "static/media/gear-alt.4f9f745a.svg";
export { ForwardRef as ReactComponent };